<template>
  <main class="main main--terms">
    <component 
      :is="noticeContent"
      class="group group--first-last group--indent typeset typeset--terms links"
    />
  </main>
</template>

<script>
// Vuex
import { mapGetters } from 'vuex';

// Models
import meta from 'models/meta';
import noticeContent from 'models/content/notice.md';

// Utils
import { createMeta } from 'utils/meta';

// Export
export default {
  name: 'view-notice',

  // Meta data
  metaInfo: {
    title: meta.terms.title,
    meta: createMeta(meta.terms.meta),
  },

  // Data
  data() {
    return {
      noticeContent,
    };
  },

  computed: {
    ...mapGetters('app', ['org']),
  },


};
</script>



// WEBPACK FOOTER //
// Notice.vue?498bbfee